<template>
  <div id="data-list-list-view">
    <vs-card>
        <div class="vx-row ">
          <div
            class="vx-col flex-1"

            v-if="$acl.check('admin')"
          >
            <vs-input
              :label="$t('CourseFeeToParticipant')"
              :disabled="true"
              v-model="CourseRequestModel.CourseFeeChargedToParticipant"
              class="mt-5 w-full"
              name="CourseName"
            />
          </div>
          <div class="vx-col flex-1" >
            <vs-select
              autocomplete
              class="mt-5 w-full"
              :label="$t('Course') "
              v-model="CourseRequestModel.CourseID"
            >
              <vs-select-item
                :value="0"
                :text="$t('OtherCourse')"
                style="background-color: #352566"
              />
              <vs-select-item
                :key="index"
                :value="item.ID"
                :text="item.Name"
                v-for="(item, index) in courses"
              />

            </vs-select>
            <span class="text-danger text-sm" v-show="errors.has('Course')">{{
              errors.first("Course")
            }}</span>
          </div>
          <div
            class="vx-col flex-1"
            v-if=" CourseRequestModel.CourseID == 0 || CourseRequestModel.CourseName"
          >
            <vs-input
              :label="$t('CourseName')"
              v-model="CourseRequestModel.CourseName"
              class="mt-5 w-full"
              name="CourseName"
            />
          </div>
          <div class="vx-col flex-1" v-if="
              CourseRequestModel.CourseID == 0 || CourseRequestModel.CourseName">
              <vs-input
              :label="$t('CourseDurationInDay')"
              v-model="CourseRequestModel.CourseDurationInDay"
              type="number"
              class="mt-5 w-full"
              name="CourseName"
              />
            </div>
        </div>
        <div class="vx-row flex-1">
          <div
            class="vx-col flex-1"

            v-if="CourseRequestModel.CourseID != 0"
          >
            <vs-select
              class="mt-5 w-full"
              :label="$t('CourseLanguage')"
              v-model="CourseRequestModel.CourseLanguageID"
            >
              <vs-select-item
                :value="0"
                :text="$t('OtherLanguage')"
                style="background-color: #352566"
              />
              <vs-select-item
                :key="index"
                :value="item.ID"
                :text="item.Name"
                v-for="(item, index) in languages"
              />

            </vs-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('CourseLanguage')"
              >{{ errors.first("CourseLanguage") }}</span
            >
          </div>
          <div
            class="vx-col flex-1"
            v-if="
              CourseRequestModel.CourseLanguageID == 0 ||
              CourseRequestModel.CourseLanguageName ||
              CourseRequestModel.CourseID == 0
            "
          >
            <vs-input
              :label="$t('CourseLanguageName')"
              v-model="CourseRequestModel.CourseLanguageName"
              class="mt-5 w-full"
              name="CourseLanguageName"
            />
          </div>
        </div>
        <div class="vx-row flex-1" >
          <div
            class="vx-col flex-1"

            v-if="$acl.check('admin')"
          >
            <p>{{$t('Organization')}}</p>
            <v-select
              label="FullName"
              class="w-full"
              autocomplete
              v-model="CourseRequestModel.CustomerID"
              :options="customers"
              :reduce="(ID) => ID.ID"
            />

            <span class="text-danger text-sm" v-show="errors.has('Customer')">{{
              errors.first("Customer")
            }}</span>
          </div>

          <div  class="vx-col  flex-1 mt-5">
            <vs-input
              :label="$t('NoOfTrainee')"
              v-model="CourseRequestModel.NoOfTrainee"
              class="mt-5 w-full"
              type="number"
              min=1
              name="NoOfTrainee"
               @change="ChangeNoOfTrainee()"
            />

          </div>
        </div>
        <div class="vx-row flex-1 mt-5" >
          <div
            class="vx-col flex-1"

          >
            <label>{{$t('RequestStartDate')}}</label>
                <datepicker
                  name="Request Start Date"
                  format="yyyy-MM-dd"
                  :disabledDates="disabledDates"
                  v-model="CourseRequestModel.RequestStartDate"
                  v-bind:v-validate="{ required: true, date_format: 'YYYY-MM-DD' }"
                ></datepicker>
            <span
              class="text-danger text-sm"
              v-show="errors.has('RequestStartDate')"
              >{{ errors.first("RequestStartDate") }}</span
            >
          </div>
          <div class="vx-col flex-1" >
            <p>{{$t('PaymentType')}}</p>

            <v-select
              label="Name"
              class="w-full"
              autocomplete
              v-model="CourseRequestModel.PaymentTypeID"
              :options="PaymentTypes"
              :reduce="(ID) => ID.ID"
            />

            <span
              class="text-danger text-sm"
              v-show="errors.has('PaymentType')"
              >{{ errors.first("PaymentType") }}</span
            >
          </div>
        </div>
        <div class="vx-row mt-5 ">
          <div class="vx-col flex-1">
            <p>{{$t('CourseType')}}</p>

            <v-select
              label="Name"
              class="w-full"
              autocomplete
              v-model="CourseRequestModel.CourseTypeID"
              :options="getCourseType"
              :reduce="(ID) => ID.ID"
            />

            <span
              class="text-danger text-sm"
              v-show="errors.has('CourseMode')"
              >{{ errors.first("CourseMode") }}</span
            >
          </div>
          <div class="vx-col flex-1">
            <p>{{$t('RequestLocation')}}</p>

            <v-select
              label="Name"
              class="w-full"
              autocomplete
              v-model="CourseRequestModel.RequestLocationID"
              :options="RequestLocations"
              @input="changeText"
              :reduce="(ID) => ID.ID"
            />

            <span
              class="text-danger text-sm"
              v-show="errors.has('RequestLocation')"
              >{{ errors.first("RequestLocation") }}</span
            >
          </div>
 <div class="vx-col flex-1" v-if="CourseRequestModel.RequestLocationID==1">
            <p> {{$t('Location')}}</p>

           <vs-input  v-model="CourseRequestModel.LocationText"  class="w-full" name="LocationText"/>
            <span class="text-danger text-sm"  v-show="errors.has('LocationText')">{{ errors.first('LocationText') }}</span>
        </div>

        </div>

    </vs-card>

    <vs-card>
      <vs-table>
           <template slot="thead">
                  <vs-th sort-key="Name">{{$t('FullName')}}</vs-th>
                  <vs-th sort-key="Provider">{{$t('JobTitle')}}</vs-th>
                  <vs-th sort-key="Code">{{$t('IndustrySector')}}</vs-th>
            </template>
            <tbody>
                <vs-tr v-for="(tr, indextr) in CourseRequestModel.CourseRequestTrainees" :key="indextr">
                   <vs-td>
                      <vs-input
                          v-model="tr.TraineeName"
                          required
                        />
                   </vs-td>
                   <vs-td>
                      <vs-input
                          v-model="tr.JobTitle"
                          required
                        />
                   </vs-td>
                   <vs-td>
                       <v-select
                          autocomplete
                          label="Name"
                          v-model="tr.IndustrySectorID"
                          :options="getindustrySector"
                          append-to-body
                          :reduce="(ID) => ID.ID"
                          required
                        />
                   </vs-td>
                </vs-tr>
            </tbody>
      </vs-table>
    </vs-card>

    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <div>
            <vs-button type="border" class="mr-5" color="danger" @click="cancel"
              >{{$t('Cancel')}}</vs-button
            >
            <vs-button
              class="ml-auto mt-2"
              @click="Submit"
              :disabled="!validateForm"
              >{{$t('Submit')}}
            </vs-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moduleIndustrySector from "@/store/settings/industrySector/moduleIndustrySector.js";
import moduleCourseRequest from "@/store/courseRequest/moduleCourseRequest.js";
import moduleCourse from "@/store/course/moduleCourse.js";
import modulePaymentType from "@/store/settings/paymentType/modulePaymentType.js";
import moduleRequestLocation from "@/store/settings/requestLocation/moduleRequestLocation.js";
import moduleLanguage from "@/store/settings/language/moduleLanguage.js";
import Datepicker from "vuejs-datepicker";
import moduleCourseType from "@/store/settings/courseType/moduleCourseType.js";
import vSelect from "vue-select";
export default {
  components: {
    // CourseRequestMainData,
    Datepicker,
    vSelect,
  },
  data() {
    return {
       disabledDates: {
        to: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()+15), // Disable all dates up to specific date
        from: new Date(new Date().getFullYear()+2, new Date().getMonth(), 1), // Disable all dates after specific date
        days: [1,2,3,4,5,6],
      },
      CourseRequestModel: {
        CourseRequestTrainees:[]
      },
      NoOfTrainee:["3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25"]
    };
  },
  computed: {
    getCourseType() {
      return this.$store.state.courseTypeList.courseTypes;
    },
    // validateForm() {
    //   debugger;
    //   return (
    //    ( (this.CourseRequestModel.RequestLocationID==1&&this.CourseRequestModel.LocationText!=undefined&&this.CourseRequestModel.LocationText!="")||this.CourseRequestModel.RequestLocationID==2)&&
    //     this.CourseRequestModel.RequestStartDate != undefined &&
    //     (this.$acl.check("customer") ||
    //       this.CourseRequestModel.NoOfTrainee != undefined) &&
    //     (this.CourseRequestModel.CourseID > 0 ||
    //       this.CourseRequestModel.CourseName != undefined) &&
    //     this.CourseRequestModel.PaymentTypeID > 0 &&
    //     this.CourseRequestModel.RequestLocationID > 0
    //   );
    // },

    validateForm() {
  let isValid = true;
  this.CourseRequestModel.CourseRequestTrainees.forEach(tr => {
    if (!tr.TraineeName || !tr.JobTitle || !tr.IndustrySectorID) {
      isValid = false;
    }
  });

  return (
    ((this.CourseRequestModel.RequestLocationID == 1 && this.CourseRequestModel.LocationText != undefined && this.CourseRequestModel.LocationText != "") || this.CourseRequestModel.RequestLocationID == 2) &&
    this.CourseRequestModel.RequestStartDate != undefined &&
    (this.$acl.check("customer") || this.CourseRequestModel.NoOfTrainee != undefined) &&
    (this.CourseRequestModel.CourseID > 0 || this.CourseRequestModel.CourseName != undefined) &&
    this.CourseRequestModel.PaymentTypeID > 0 &&
    this.CourseRequestModel.RequestLocationID > 0 &&
    isValid &&
    this.CourseRequestModel.CourseRequestTrainees.every(tr => !!tr.TraineeName && !!tr.JobTitle)
  );
},
    courses() {
      return this.$store.state.courseList.courses;
    },
    PaymentTypes() {
      return this.$store.state.PaymentTypeList.PaymentTypes;
    },
    RequestLocations() {
      return this.$store.state.RequestLocationList.RequestLocations;
    },

    languages() {
      return this.$store.state.languageList.languages;
    },
     getindustrySector()
    {
        return this.$store.state.industrySectorList.industrySectors;
    },
  },
  methods: {
    changeText(){
    if(this.CourseRequestModel.RequestLocationID==2){
     this.CourseRequestModel.LocationText ="";
    }
    },
    ChangeNoOfTrainee()
    {
         this.CourseRequestModel.CourseRequestTrainees = [];
         var NoOfTrainee = this.CourseRequestModel.NoOfTrainee;
         for(var i=0;i<NoOfTrainee;i++)
           this.CourseRequestModel.CourseRequestTrainees.push({});
    },
    cancel() {
      this.$router.push("/FollowCourseRequest");
    },
    notifyAlert(color, title, text) {
      this.$vs.notify({
        color: color,
        title: title,
        text: text,
      });
    },
    Submit() {
      if (this.CourseRequestModel.CourseID == 0) {
        this.CourseRequestModel.Course = null;
        this.CourseRequestModel.CourseID = undefined;
      }
      if (this.CourseRequestModel.CourseLanguageID == 0) {
        this.CourseRequestModel.Language = null;
        this.CourseRequestModel.CourseLanguageID = undefined;
      }
      this.$vs.loading();
      this.$store
        .dispatch(
          "courseRequestList/AddCourseRequestForCustomer",
          this.CourseRequestModel
        )
        .then(() => {
          this.$vs.loading.close();
          this.notifyAlert(
            "success",
            this.$t("Success"),
            this.$t("Yourrequestsubmittedsuccessfully"));
          this.$router.push("/");
        })
        .catch(() => {
          this.$vs.loading.close();
          this.notifyAlert(
            "danger",
            this.$t("Error"),
          this.$t("Unexpectederrorpleasetryagain")

          );
        });
    },
  },

  created() {
    if (!moduleCourse.isRegistered) {
      this.$store.registerModule("courseList", moduleCourse);
      moduleCourse.isRegistered = true;
    }
    this.$store.dispatch("courseList/fetchDataListItems");
 if (!moduleIndustrySector.isRegistered) {
      this.$store.registerModule("industrySectorList", moduleIndustrySector);
      moduleIndustrySector.isRegistered = true;
    }
    if (!modulePaymentType.isRegistered) {
      this.$store.registerModule("PaymentTypeList", modulePaymentType);
      modulePaymentType.isRegistered = true;
    }
    this.$store.dispatch("PaymentTypeList/fetchDataListItems");

    if (!moduleRequestLocation.isRegistered) {
      this.$store.registerModule("RequestLocationList", moduleRequestLocation);
      moduleRequestLocation.isRegistered = true;
    }
    this.$store.dispatch("RequestLocationList/fetchDataListItems");

    if (!moduleLanguage.isRegistered) {
      this.$store.registerModule("languageList", moduleLanguage);
      moduleLanguage.isRegistered = true;
    }
    if (!moduleCourseType.isRegistered) {
      this.$store.registerModule("courseTypeList", moduleCourseType);
      moduleCourseType.isRegistered = true;
    }
    this.$store.dispatch("industrySectorList/fetchDataListItems");
    this.$store.dispatch("courseTypeList/fetchDataListItems");
    this.$store.dispatch("languageList/fetchDataListItems");

    if (!moduleCourseRequest.isRegistered) {
      this.$store.registerModule("courseRequestList", moduleCourseRequest);
      moduleCourseRequest.isRegistered = true;
    }
  },
};
</script>


<style lang="scss">
.vs__dropdown-menu {
  z-index: 50000000000000;
  position: absolute;
}
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

<style lang="css">
  .disabled-upload{
    display: none
  }
  .vs-table--not-data
{
  display: none;
}
.vdp-datepicker__calendar
{
  z-index: 700!important;
}
</style>
